import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import { runOwsRequestWithMonitor, Feature } from '../../..';
import {
    CreatePersonaRequest,
    PersonaType,
    TFactories,
    getServiceAsync,
} from '../../../../service';

export interface Property {
    name: string;
    newValue: string;
    oldValue: string;
}

function buildRequest(
    serviceFactory: TFactories,
    properties: Property[],
    parentFolderId: string
): CreatePersonaRequest {
    const targetFolderID = serviceFactory.targetFolderId({
        BaseFolderId: serviceFactory.folderId({ Id: parentFolderId }),
    });

    const request = serviceFactory.createPersonaRequest({
        PersonaId: null,
        PersonTypeString: 'Person',
        PropertyUpdates: [],
        ParentFolderId: targetFolderID,
    });

    if (properties && properties.length > 0) {
        properties.forEach((property: Property) => {
            request.PropertyUpdates.push(
                serviceFactory.personaPropertyUpdate({
                    Path: serviceFactory.propertyUri({ FieldURI: property.name }),
                    OldValue: property.oldValue,
                    NewValue: property.newValue,
                })
            );
        });
    }

    return request;
}

export function createPersona(
    properties: Property[],
    parentFolderId: string,
    additionalLogProperties?: {}
): Promise<PersonaType> {
    return getServiceAsync().then(service =>
        runOwsRequestWithMonitor({
            scenarioName: 'CreatePersona',
            feature: Feature.ContactManagement,
            operation: () =>
                service.Operation.createPersonaOperation({
                    request: {
                        Header: getJsonRequestHeader(),
                        Body: buildRequest(service.Factory, properties, parentFolderId),
                    },
                }),
            qoSConfig: additionalLogProperties && {
                additionalQoSLogProperty: additionalLogProperties,
            },
            transformResponse: (personaType: PersonaType) => personaType,
        })
    );
}
